import { appHomeRoute, isProtectedRoute } from "~/routes";

export const useRedirect = async () => {
  const { loggedIn } = useAuth();
  const router = useRouter();

  if (!loggedIn.value && isProtectedRoute(router.currentRoute.value.path)) {
    window.location.href = appHomeRoute.path;
  }
};
